<script setup lang="ts">
import {
  withDefaults,
  defineProps,
  defineEmits,
  defineModel,
  watch,
} from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import lockedIcon from "@/assets/icons/locked.svg";

withDefaults(
  defineProps<{
    type: "transparent" | "white";
    isBlocked?: boolean;
  }>(),
  {
    type: "transparent",
    isBlocked: false,
  }
);

const emits = defineEmits(["opened"]);
const isOpen = defineModel<boolean>({ default: false });

watch(isOpen, (newValue) => {
  if (newValue) {
    emits("opened");
  }
});
</script>

<template>
  <div class="w-full mb-2">
    <div
      class="border rounded-2xl border-ternary group"
      :class="{ 'bg-white': isOpen || type === 'white' }"
    >
      <button
        class="w-full text-left pl-4 pr-2 py-3 transition flex items-center h-16"
        :class="isBlocked ? 'justify-start gap-4' : 'justify-between'"
        @click="isOpen = !isOpen"
      >
        <img :src="lockedIcon" alt="locked" class="size-5" v-if="isBlocked" />
        <span
          class="text-xl font-semibold leading-[28px]"
          :class="isOpen ? 'text-active' : 'text-brown group-hover:text-active'"
        >
          <slot name="title" />
        </span>
        <span
          v-if="!isBlocked"
          class="size-10 text-white rounded-lg flex items-center justify-center"
          :class="
            isOpen
              ? 'bg-active'
              : 'bg-brown-gradient group-hover:bg-orange-gradient'
          "
        >
          <svg
            :class="[
              'w-5 h-5 transform transition-transform',
              isOpen ? 'rotate-180' : 'rotate-0',
            ]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </button>

      <div v-if="isOpen" class="mx-4 pt-6 pb-4 bg-white border-t text-left">
        <slot name="faq-content" />

        <button
          class="flex justify-center items-center w-full h-[60px] mt-6 text-xl font-normal leading-100p text-brown border border-divider rounded-[100px] hover:bg-hover hover:border-active hover:text-active transition-all duration-300 ease-in-out"
          @click="isOpen = false"
        >
          <slot name="collapse-text-btn" />
          <ArrowIcon class="ml-6" />
        </button>
      </div>
    </div>
  </div>
</template>
